import { render, staticRenderFns } from "./certificadoOS.vue?vue&type=template&id=043a3b29&scoped=true"
import script from "./certificadoOS.vue?vue&type=script&lang=js"
export * from "./certificadoOS.vue?vue&type=script&lang=js"
import style0 from "./certificadoOS.vue?vue&type=style&index=0&id=043a3b29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "043a3b29",
  null
  
)

export default component.exports